import { useQuery } from "react-query";
import axios from "../services/api/api";

const FetchLicenseManagementCustomers = async () => {
  const res = await axios.get(`/LicMgt/GetCustomers`);
  return res.data.result;
};
export function GetLicenseManagementCustomers() {
  return useQuery(
    ["FetchLicenseManagementCustomers"],
    () => FetchLicenseManagementCustomers(),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

const FetchLicenseManagementCourses = async () => {
  const res = await axios.get(`/LicMgt/GetCourses`);
  return res.data.result;
};
export function GetLicenseManagementCourses() {
  return useQuery(
    ["FetchLicenseManagementCourses"],
    () => FetchLicenseManagementCourses(),
    {
      retry: 3,
      refetchOnWindowFocus: false,
    }
  );
}

const FetchCustomerGroups = async () => {
  const res = await axios.get(`/School/GetGroups`);
  return res.data.result;
};
export function GetCustomerGroups() {
  return useQuery(["FetchCustomerGroups"], () => FetchCustomerGroups(), {
    retry: 3,
    refetchOnWindowFocus: false,
  });
}
